import React, { useState } from 'react';
import { useStaticQuery } from 'gatsby';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const LanguageContext = /*#__PURE__*/React.createContext({});
export const LanguageProvider = _ref => {
  let {
    currentLang,
    children
  } = _ref;
  const languages = useStaticQuery(query).directusProject.languages.filter(el => el !== '');
  const {
    0: language,
    1: setCurrentLanguage
  } = useState(currentLang);
  const {
    0: availableLanguages
  } = useState(languages);
  return ___EmotionJSX(LanguageContext.Provider, {
    value: {
      language,
      setCurrentLanguage,
      availableLanguages
    }
  }, children);
};
const query = "3139401397";